import { COMMERCE_ACTIONS } from "@/theme1/lib/commerceActions";
import { useCommerce } from "@/theme1/hooks/useCommerce";

export function useWishlist() {
  const { state, dispatch, selectors } = useCommerce();

  const add = (product) => {
    dispatch({
      type: COMMERCE_ACTIONS.ADD_TO_WISHLIST,
      payload: { product },
    });
  };

  const remove = (slug) => {
    dispatch({
      type: COMMERCE_ACTIONS.REMOVE_FROM_WISHLIST,
      payload: { slug },
    });
  };

  const toggleWishlist = (product) => {
    if (isWishlisted(product.slug)) {
      remove(product.slug);
    } else {
      add(product);
    }
  };

  const clear = () => {
    dispatch({ type: COMMERCE_ACTIONS.CLEAR_WISHLIST });
  };

  const moveToCart = (product, options = {}) => {
    dispatch({
      type: COMMERCE_ACTIONS.MOVE_WISHLIST_TO_CART,
      payload: {
        slug: product.slug,
        options,
      },
    });
  };

  const isWishlisted = (slug) => {
    return state.wishlist.some((item) => item.slug === slug);
  };

  return {
    wishlist: state.wishlist,
    wishlistProducts: state.wishlist,
    wishlistCount: selectors.getWishlistCount(),

    add,
    addToWishlist: add,

    remove,
    removeFromWishlist: remove,

    toggleWishlist,

    clear,
    clearWishlist: clear,

    moveToCart,
    isWishlisted,
  };
}